export default "__VITE_ASSET__otEIWlGE__"